document.addEventListener('DOMContentLoaded', function() {
    (function (window, document) {

        const addSelectClass = () => {
            // Enable obfuscation link
            let selects = document.querySelectorAll('select');
            const applyIsSelected = function(select) {
                if(select.value) {
                    select.classList.add('selected');
                } else {
                    select.classList.remove('selected');
                }
            };

            selects.forEach(function (select) {
                applyIsSelected(select);
                select.addEventListener('change', function(event) {
                    applyIsSelected(select);
                });
            });
        }

        addSelectClass();

    })(window, document);
});
